import IconCount from './IconCount';

export default IconCount;
